import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, effect } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult } from '@azure/msal-browser';

import { environment } from '../environments/environment';
import { timer } from 'rxjs/internal/observable/timer';
import { identityUrls } from './shared/integration-urls/identity-urls';
import { SharedService } from '@shared/services/shared.service';
import { HeaderComponent } from './header/header.component';
import { GenericLoaderComponent } from './shared/generic-loader/generic-loader.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { SessionTimeoutService } from './shared/services/session-timeout.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    GenericLoaderComponent,
    MsalModule,
    HeaderComponent,
    DialogModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  currentYear = new Date().getFullYear();
  isIframe = false;
  displayScreen: boolean = false;
  headerEnvironment: any = environment;
  selectedHeader = 'Home';
  profile = {};
  GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';
  private readonly Token_Refresh_MArgin = 5 * 60 * 1000; //Refresh 1 min Brfore
  headerInputs: any = {};
  links: any;
  
  // Session timeout dialog properties
  public sessionTimeoutDialogOpened = false;
  public dialogSettings: any = {
    closable: false
  };

  constructor(
    private http: HttpClient, 
    private msalService: MsalService, 
    private router: Router, 
    private sharedService: SharedService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    this.sessionTimeoutService.sessionExpired$.subscribe(expired => {
      if (expired) {
        this.sessionTimeoutDialogOpened = true;
      }
    });
  }

  ngOnInit() {
    this.msalService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result !== null && result.account !== null) {
          this.msalService.instance.setActiveAccount(result.account);
        }
      },
      error: (error) => console.log(error)
    })
    this.isIframe = window !== window.parent && !window.opener;
    this.getProfile();
    
    // Start session timeout tracking
    this.sessionTimeoutService.startSessionTimer();
  }
  
  ngOnDestroy() {
    // Stop session timeout tracking
    this.sessionTimeoutService.stopSessionTimer();
  }

  getProfile() {
    this.http.get(this.GRAPH_ENDPOINT).subscribe((profile) => {
      this.getAzureADAPIToken()
      this.profile = profile;
      sessionStorage.setItem('profile', JSON.stringify(profile));
      if (profile) {
        this.getUserDetails(profile['mail']);
      }
      setTimeout(() => {
         this.cookieConsentScript();
        this.displayScreen = true;
        this.router.navigateByUrl('/');
      }, 600);
    });
  }

  getUserDetails(email) {
    // Implement user details fetching logic here
  }

  getAzureADAPIToken() {
    let activeAccount: AccountInfo | null = this.msalService.instance.getActiveAccount();
    // Set the active account if not already set
    if (!activeAccount) {
      const allAccounts = this.msalService.instance.getAllAccounts();
      if (allAccounts.length > 0) {
        activeAccount = allAccounts[0];
        this.msalService.instance.setActiveAccount(activeAccount);
      }
    }
    const scopes = environment.scopes;

    if (activeAccount) {
      this.msalService.acquireTokenSilent({ scopes: scopes }).subscribe(tokenResponse => {
        const newToken = tokenResponse.accessToken;        
        const idTokenClaims = tokenResponse.idTokenClaims;
        const roles = idTokenClaims['roles'] ;       
        // Store the new token in sessionStorage
        sessionStorage.setItem('roles', roles?.join(','));       
        sessionStorage.setItem('access_token', newToken);


        const expirationDate = new Date(tokenResponse.expiresOn);
        const currentTime = new Date();
        const timeToExpiration = expirationDate.getTime() - currentTime.getTime();
        console.log(timeToExpiration);
        this.refreshTokenBeforeExpiration(timeToExpiration);// 60000ms means 1 min
      })
    }
  }

  refreshTokenBeforeExpiration(refreshTime: number): void {

    let timeBeforeRefresh = refreshTime - this.Token_Refresh_MArgin; // Refresh Token Before 5 min
    if (timeBeforeRefresh > 0) {
      timer(timeBeforeRefresh).subscribe(() => {

        this.getAzureADAPIToken(); // Refresh The Token before expiration
        
      });
    }
  }

   cookieConsentScript() {
        let scriptEle = document.createElement("script");
        scriptEle.setAttribute("src", "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js");
        scriptEle.setAttribute("type", "text/javascript");
        let href = window.location.href;
        console.log("herf =" + href);
        if (href.includes("https://ddr.runtime.deloitte.com")) {
            scriptEle.setAttribute("data-domain-script", "7d0e743c-36b6-4c22-8b2f-9f3001a69b43");
        } else {
            scriptEle.setAttribute("data-domain-script", "7d0e743c-36b6-4c22-8b2f-9f3001a69b43-test");
        }
        scriptEle.setAttribute("charset", "UTF-8");
        document.body.appendChild(scriptEle);
    }
  
  // Session timeout dialog handlers
  public onLogout(): void {
    this.sessionTimeoutDialogOpened = false;
    this.sessionTimeoutService.logout();
  }
}
